export const MIN_STRING_LENGTH = 1
export const MAX_SEGMENT_NAME_LENGTH = 50

export const MIN_PRIORITY = 1
export const MAX_PRIORITY = 999

export const ALLOWED_SYMBOLS_REGEX = /^[a-zA-Z0-9_ -]*$/;
export const ALLOWED_SYMBOLS_MESSAGE = 'Text must contain only letters, spaces, numbers, dashes, and underscores';

